import { SvgIcon } from "@mui/material";
import i18n from "../../../../../i18n";
import styles from "./PlayOverlay.module.css";
import ReplayIcon from "../../../Resources/replay.svg?react";
import ReplayIconGlowing from "../../../Resources/replay-glowing.svg?react";
import PlayOverlayIcon from "../../../Resources/play-overlay.svg?react";
import PlayOverlayIconGlowing from "../../../Resources/play-overlay-glowing.svg?react";

type PlayOverlayProps = {
	useVideoEndedOverlay: boolean;
	isOverlayVisible: boolean;
	setPlay: () => void;
	circleClassName?: string;
	playLabel?: string;
	restartLabel?: string;
};

export default function PlayOverlay({
	useVideoEndedOverlay,
	isOverlayVisible,
	setPlay,
	circleClassName,
	playLabel,
	restartLabel,
}: PlayOverlayProps) {
	return (
		<button
			className={styles.videoOverlay}
			style={{
				opacity: isOverlayVisible ? 1 : 0,
				backgroundColor: useVideoEndedOverlay ? "#000000F2" : "#00000059",
			}}
			onClick={(e) => {
				setPlay();
				e.stopPropagation();
			}}
			aria-label={
				useVideoEndedOverlay
					? (restartLabel ?? i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.restartVideoLabel"))
					: (playLabel ?? i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.playVideoLabel"))
			}
		>
			<div
				className={[styles.overlayButtonCircle, circleClassName].filter(Boolean).join(" ")}
				style={{ backgroundColor: useVideoEndedOverlay ? "#212121" : "#000000CC" }}
			>
				{useVideoEndedOverlay ? (
					<>
						<SvgIcon
							component={ReplayIcon}
							opacity={1}
							width="78"
							viewBox="0 0 78 78"
							style={{ width: "78", height: "78", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.overlayIcon}
							aria-hidden="true"
						/>
						<SvgIcon
							component={ReplayIconGlowing}
							opacity={1}
							viewBox="0 0 78 78"
							style={{ width: "78", height: "78", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.glowingIcon}
							aria-hidden="true"
						/>
					</>
				) : (
					<>
						<SvgIcon
							component={PlayOverlayIcon}
							opacity={1}
							viewBox="0 0 78 78"
							style={{ width: "78", height: "78", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.overlayIcon}
							aria-hidden="true"
						/>
						<SvgIcon
							component={PlayOverlayIconGlowing}
							opacity={1}
							viewBox="0 0 78 78"
							style={{ width: "78", height: "78", color: "#F4F4F4", cursor: "pointer" }}
							className={styles.glowingIcon}
							aria-hidden="true"
						/>
					</>
				)}
			</div>
		</button>
	);
}
